/* ==========================================================================
   THE ARK ATTIRE - Custom Interactions
   ========================================================================== */

(function () {
  'use strict';

  /* ---- 1. Header Shrink on Scroll ---- */
  function initHeaderShrink() {
    var header = document.querySelector('.section-header');
    if (!header) return;

    window.addEventListener(
      'scroll',
      function () {
        if (window.pageYOffset > 50) {
          header.classList.add('header--scrolled');
        } else {
          header.classList.remove('header--scrolled');
        }
      },
      { passive: true }
    );
  }

  /* ---- 2. Parallax for Fixed Banners ---- */
  function initParallax() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var banners = document.querySelectorAll('.animate--fixed .banner__media img');
    if (banners.length === 0) return;

    window.addEventListener(
      'scroll',
      function () {
        for (var i = 0; i < banners.length; i++) {
          var banner = banners[i].closest('.banner');
          if (!banner) continue;
          var rect = banner.getBoundingClientRect();
          var yPos = -(rect.top * 0.3);
          banners[i].style.transform = 'translate3d(0,' + yPos + 'px,0)';
        }
      },
      { passive: true }
    );
  }

  /* ---- 3. Touch Swipe for Sliders ---- */
  function initTouchSwipe() {
    var sliders = document.querySelectorAll('.slider');

    for (var s = 0; s < sliders.length; s++) {
      (function (slider) {
        var startX = 0;
        var startY = 0;
        var isHorizontal = false;

        slider.addEventListener(
          'touchstart',
          function (e) {
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
            isHorizontal = false;
          },
          { passive: true }
        );

        slider.addEventListener(
          'touchmove',
          function (e) {
            if (!startX) return;
            var diffX = Math.abs(e.touches[0].clientX - startX);
            var diffY = Math.abs(e.touches[0].clientY - startY);
            if (diffX > diffY && diffX > 10) {
              isHorizontal = true;
            }
          },
          { passive: true }
        );

        slider.addEventListener(
          'touchend',
          function (e) {
            if (!isHorizontal) return;
            var endX = e.changedTouches[0].clientX;
            var diff = startX - endX;

            if (Math.abs(diff) > 50) {
              var parent = slider.closest('slider-component');
              if (!parent) return;
              var btn = parent.querySelector(
                diff > 0 ? '.slider-button--next' : '.slider-button--prev'
              );
              if (btn) btn.click();
            }
            startX = 0;
          },
          { passive: true }
        );
      })(sliders[s]);
    }
  }

  /* ---- 4. Smooth Scroll for Anchor Links ---- */
  function initSmoothScroll() {
    var anchors = document.querySelectorAll('a[href^="#"]');
    for (var i = 0; i < anchors.length; i++) {
      anchors[i].addEventListener('click', function (e) {
        var href = this.getAttribute('href');
        if (href === '#') return;
        var target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
  }

  /* ---- 5. Lazy Image Fade-In ---- */
  function initImageFadeIn() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    var images = document.querySelectorAll('.card__media img[loading="lazy"]');
    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            entries[i].target.style.opacity = '1';
            observer.unobserve(entries[i].target);
          }
        }
      },
      { rootMargin: '50px' }
    );

    for (var i = 0; i < images.length; i++) {
      images[i].style.opacity = '0';
      images[i].style.transition = 'opacity 0.5s ease';
      if (images[i].complete) {
        images[i].style.opacity = '1';
      } else {
        observer.observe(images[i]);
      }
    }
  }

  /* ---- 6. Video Hero Autoplay Control ---- */
  function initVideoHero() {
    var heroes = document.querySelectorAll('.video-hero');
    if (heroes.length === 0) return;
    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var video = entries[i].target.querySelector('video');
          if (!video) continue;
          if (entries[i].isIntersecting) {
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        }
      },
      { threshold: 0.25 }
    );

    for (var i = 0; i < heroes.length; i++) {
      observer.observe(heroes[i]);
    }
  }

  /* ---- 7. Marquee Accessibility ---- */
  function initMarqueeAccessibility() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var tracks = document.querySelectorAll('[class*="marquee-track-"]');
      for (var i = 0; i < tracks.length; i++) {
        tracks[i].style.animation = 'none';
      }
    }
  }

  /* ---- 8. Product Carousel Custom Arrows ---- */
  function initProductCarouselArrows() {
    var galleries = document.querySelectorAll('media-gallery');
    galleries.forEach(function(gallery) {
      var prevBtn = gallery.querySelector('[data-ark-prev]');
      var nextBtn = gallery.querySelector('[data-ark-next]');
      var counterCurrent = gallery.querySelector('[data-ark-current]');
      var counterEl = gallery.querySelector('[data-ark-counter]');
      var sliderComp = gallery.querySelector('slider-component');
      var slider = gallery.querySelector('[id^="Slider-Gallery-"]');

      if (!prevBtn || !nextBtn || !slider) return;

      var items = Array.from(slider.querySelectorAll('.product__media-item'));
      var visibleItems = items.filter(function(el) { return el.offsetWidth > 0; });

      if (visibleItems.length < 2) {
        prevBtn.style.display = 'none';
        nextBtn.style.display = 'none';
        if (counterEl) counterEl.style.display = 'none';
        return;
      }

      function getItemWidth() {
        return visibleItems[0] ? visibleItems[0].offsetWidth : slider.offsetWidth;
      }

      function getCurrentIndex() {
        var itemWidth = getItemWidth();
        if (itemWidth === 0) return 0;
        return Math.round(slider.scrollLeft / itemWidth);
      }

      function updateButtons() {
        var idx = getCurrentIndex();
        var total = visibleItems.length;
        prevBtn.disabled = (idx <= 0);
        nextBtn.disabled = (idx >= total - 1);
        if (counterCurrent) counterCurrent.textContent = idx + 1;
      }

      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var itemWidth = getItemWidth();
        slider.scrollTo({
          left: slider.scrollLeft - itemWidth,
          behavior: 'smooth'
        });
      });

      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var itemWidth = getItemWidth();
        slider.scrollTo({
          left: slider.scrollLeft + itemWidth,
          behavior: 'smooth'
        });
      });

      var scrollTimer;
      slider.addEventListener('scroll', function() {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(updateButtons, 80);
      }, { passive: true });

      /* Initial state after layout settles */
      setTimeout(updateButtons, 200);
      setTimeout(updateButtons, 600);
    });
  }

  /* ---- Quick-Add Modal ----
     Click on [data-qa-trigger] (with data-product-handle) → fetch product
     JSON → render quick-view modal → user picks size/qty → POST to /cart/add.js.

     Designed to be generic: any product card on any section can use this
     by adding the trigger anchor with the right data attributes. Currently
     wired in snippets/bs-product-card.liquid. */
  function initQuickAdd() {
    var modal = document.querySelector('[data-qa-modal]');
    if (!modal) return;

    var bodyEl       = modal.querySelector('[data-qa-body]');
    var loadingEl    = modal.querySelector('[data-qa-loading]');
    var lastFocused  = null;
    var productCache = {};      /* handle → fetched product JSON */
    var currentProduct = null;  /* state for selected variant + qty */
    var selectedVariant = null;
    var selectedQty = 1;
    var galleryIndex = 0;
    var loadToken = 0;   /* invalidates stale fetches so a slow response can't overwrite a newer/closed view */

    function moneyFormat(cents) {
      /* Use Shopify's published format if available (set in theme settings),
         else fall back to a sensible PKR-friendly default. */
      var fmt = (window.theme && window.theme.moneyFormat) ||
                (window.Shopify && window.Shopify.money_format) ||
                'Rs.{{amount}}';
      var amt = (cents / 100).toFixed(2)
                .replace(/\d(?=(\d{3})+\.)/g, '$&,');
      return fmt.replace(/\{\{\s*amount\s*\}\}/g, amt)
                .replace(/\{\{\s*amount_no_decimals\s*\}\}/g,
                         Math.round(cents / 100).toLocaleString());
    }

    function escapeHtml(str) {
      return String(str || '')
        .replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    /* Resize a Shopify CDN image URL to a target width. Tries the filename
       suffix style first (`image_720x.jpg`), falls back to the `?width=720`
       query param if the URL doesn't match the expected pattern. Also adds
       https: prefix to protocol-relative URLs. */
    function resizeImage(src, width) {
      if (!src) return '';
      var url = src;
      if (url.indexOf('//') === 0) url = 'https:' + url;
      var resized = url.replace(
        /(\.(?:jpe?g|png|gif|webp|avif))(\?|$)/i,
        '_' + width + 'x$1$2'
      );
      if (resized === url) {
        /* No filename match — append width query param instead */
        resized = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + width;
      }
      return resized;
    }

    function findVariantByOptions(product, options) {
      /* options is array aligned to product.options ordering */
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var matchesAll = true;
        for (var j = 0; j < options.length; j++) {
          if (v.options[j] !== options[j]) { matchesAll = false; break; }
        }
        if (matchesAll) return v;
      }
      return null;
    }

    function render(product) {
      if (!product || !product.variants || !product.variants.length) {
        /* Nothing safe to show — fall back to the PDP rather than a broken modal */
        if (product && product.handle) window.location.href = '/products/' + product.handle;
        return;
      }
      currentProduct  = product;
      galleryIndex    = 0;
      selectedQty     = 1;
      /* Default: first available variant, else first variant */
      selectedVariant = null;
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].available) {
          selectedVariant = product.variants[i];
          break;
        }
      }
      if (!selectedVariant) selectedVariant = product.variants[0];

      var images = (product.images && product.images.length)
        ? product.images
        : (product.featured_image ? [product.featured_image] : []);

      /* Normalize URLs: add https: prefix to protocol-relative URLs.
         Use ORIGINAL URLs for main image (guaranteed to load), small
         resized URLs for thumbnails (faster). */
      images = images.map(function(src) {
        if (!src) return src;
        return (src.indexOf('//') === 0) ? 'https:' + src : src;
      });

      /* Build gallery */
      var thumbsHtml = '';
      var firstMainSrc = '';
      if (images.length > 0) {
        firstMainSrc = resizeImage(images[0], 720);
        thumbsHtml = images.slice(0, 6).map(function(src, idx) {
          var thumbUrl = resizeImage(src, 120);
          var fullUrl  = resizeImage(src, 720);
          return '<button type="button" class="qa-thumb' + (idx === 0 ? ' is-active' : '') +
                 '" data-qa-thumb="' + idx + '" data-full-src="' + escapeHtml(fullUrl) +
                 '" aria-label="View image ' + (idx + 1) + '">' +
                 '<img src="' + escapeHtml(thumbUrl) + '" alt="" loading="lazy" width="60" height="60">' +
                 '</button>';
        }).join('');
      }

      /* Build options (one row per option that has > 1 value) */
      var optionsHtml = '';
      (product.options || []).forEach(function(optName, oi) {
        /* Some Shopify .js endpoints return options as array of strings,
           others as array of objects { name, position, values }. Handle both. */
        var name   = (typeof optName === 'string') ? optName : optName.name;
        var values = (typeof optName === 'string')
          ? (function() {
              var s = {};
              product.variants.forEach(function(v) { s[v.options[oi]] = true; });
              return Object.keys(s);
            })()
          : optName.values;

        if (!values || values.length < 2) return; /* skip single-value options */

        var isColor = /colou?r/i.test(name);
        optionsHtml += '<div class="qa-option" data-qa-option-index="' + oi + '">' +
          '<div class="qa-option__label">' +
            '<span class="qa-option__name">' + escapeHtml(name) + '</span>' +
            '<span class="qa-option__value" data-qa-option-value></span>' +
          '</div>' +
          '<div class="qa-option__values' + (isColor ? ' qa-option__values--swatch' : '') + '" role="radiogroup" aria-label="' + escapeHtml(name) + '">' +
            values.map(function(val) {
              if (isColor) {
                var dc = String(val).toLowerCase().replace(/^\s+|\s+$/g, '');
                return '<button type="button" class="qa-pill qa-pill--swatch" role="radio" title="' + escapeHtml(val) + '"' +
                  ' data-qa-option="' + oi + '" data-qa-value="' + escapeHtml(val) + '">' +
                  '<span class="color-swatch-circle" data-color="' + escapeHtml(dc) + '"></span>' +
                  '<span class="visually-hidden">' + escapeHtml(val) + '</span>' +
                  '</button>';
              }
              return '<button type="button" class="qa-pill" role="radio"' +
                ' data-qa-option="' + oi + '" data-qa-value="' + escapeHtml(val) + '">' +
                escapeHtml(val) + '</button>';
            }).join('') +
          '</div></div>';
      });

      var hasCompare = selectedVariant && selectedVariant.compare_at_price &&
                       selectedVariant.compare_at_price > selectedVariant.price;
      var priceHtml =
        '<span class="qa-price__current" data-qa-price>' + moneyFormat(selectedVariant.price) + '</span>' +
        (hasCompare ? '<span class="qa-price__compare" data-qa-compare>' +
                      moneyFormat(selectedVariant.compare_at_price) + '</span>' : '');

      bodyEl.innerHTML =
        '<div class="qa-modal__inner">' +
          '<div class="qa-gallery' + (images.length > 1 ? ' qa-gallery--has-thumbs' : '') + '">' +
            (images.length > 1 ? '<div class="qa-thumbs">' + thumbsHtml + '</div>' : '') +
            '<div class="qa-main">' +
              (images.length > 1
                ? '<button type="button" class="qa-arrow qa-arrow--prev" data-qa-prev aria-label="Previous">' +
                  '<svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M7 1L3 5L7 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
                  '</button>' +
                  '<button type="button" class="qa-arrow qa-arrow--next" data-qa-next aria-label="Next">' +
                  '<svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M3 1L7 5L3 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
                  '</button>'
                : '') +
              (firstMainSrc
                ? '<img class="qa-main__img" data-qa-main src="' + escapeHtml(firstMainSrc) +
                  '" alt="' + escapeHtml(product.title) + '" loading="eager">'
                : '<div class="qa-main__empty">No image available</div>') +
            '</div>' +
          '</div>' +
          '<div class="qa-info">' +
            (product.vendor ? '<span class="qa-vendor">' + escapeHtml(product.vendor) + '</span>' : '') +
            '<h2 class="qa-title" id="qa-title">' + escapeHtml(product.title) + '</h2>' +
            '<div class="qa-price">' + priceHtml + '</div>' +
            optionsHtml +
            '<div class="qa-cart-row">' +
              '<div class="qa-quantity">' +
                '<button type="button" class="qa-qty-btn" data-qa-qty="-1" aria-label="Decrease quantity">−</button>' +
                '<input type="number" class="qa-qty-input" data-qa-qty-input value="1" min="1" inputmode="numeric" aria-label="Quantity">' +
                '<button type="button" class="qa-qty-btn" data-qa-qty="1" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<button type="button" class="qa-add" data-qa-add>' +
                '<span data-qa-add-label>ADD TO CART</span>' +
              '</button>' +
            '</div>' +
            '<div class="qa-feedback" data-qa-feedback role="status" aria-live="polite"></div>' +
            '<a href="/products/' + escapeHtml(product.handle) + '" class="qa-more-details">More details &rarr;</a>' +
          '</div>' +
        '</div>';

      /* Mark the initial selected pills */
      modal.querySelectorAll('.qa-pill').forEach(function(pill) {
        var oi = +pill.getAttribute('data-qa-option');
        var val = pill.getAttribute('data-qa-value');
        if (selectedVariant && selectedVariant.options[oi] === val) {
          pill.classList.add('is-selected');
          pill.setAttribute('aria-checked', 'true');
        } else {
          pill.setAttribute('aria-checked', 'false');
        }
      });
      updateOptionLabels();
    }

    function updateOptionLabels() {
      modal.querySelectorAll('[data-qa-option-index]').forEach(function(row) {
        var oi = +row.getAttribute('data-qa-option-index');
        var valEl = row.querySelector('[data-qa-option-value]');
        if (valEl && selectedVariant) valEl.textContent = '— ' + selectedVariant.options[oi];
      });
    }

    function selectOption(optIndex, value) {
      if (!currentProduct) return;
      var newOpts = (selectedVariant ? selectedVariant.options.slice() : []);
      newOpts[optIndex] = value;
      var match = findVariantByOptions(currentProduct, newOpts);
      if (!match) return; /* shouldn't happen with rectangular variant matrix */
      selectedVariant = match;

      /* Update pill state */
      modal.querySelectorAll('[data-qa-option="' + optIndex + '"]').forEach(function(p) {
        var isMatch = (p.getAttribute('data-qa-value') === value);
        p.classList.toggle('is-selected', isMatch);
        p.setAttribute('aria-checked', isMatch ? 'true' : 'false');
      });

      /* Update price */
      var priceEl   = modal.querySelector('[data-qa-price]');
      var compareEl = modal.querySelector('[data-qa-compare]');
      if (priceEl) priceEl.textContent = moneyFormat(selectedVariant.price);
      if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
        if (compareEl) {
          compareEl.textContent = moneyFormat(selectedVariant.compare_at_price);
          compareEl.style.display = '';
        }
      } else if (compareEl) {
        compareEl.style.display = 'none';
      }

      /* Update Add button label / disabled state */
      var addBtn   = modal.querySelector('[data-qa-add]');
      var addLabel = modal.querySelector('[data-qa-add-label]');
      if (addBtn && addLabel) {
        if (selectedVariant.available) {
          addBtn.disabled = false;
          addLabel.textContent = 'ADD TO CART';
        } else {
          addBtn.disabled = true;
          addLabel.textContent = 'SOLD OUT';
        }
      }

      updateOptionLabels();
    }

    function setQty(n) {
      n = Math.max(1, Math.floor(+n) || 1);
      selectedQty = n;
      var input = modal.querySelector('[data-qa-qty-input]');
      if (input) input.value = n;
    }

    function showImage(idx) {
      if (!currentProduct) return;
      var images = currentProduct.images || [];
      if (!images.length) return;
      idx = Math.max(0, Math.min(idx, images.length - 1));
      galleryIndex = idx;

      /* Update main image src */
      var mainImg = modal.querySelector('[data-qa-main]');
      var src = images[idx];
      if (src && src.indexOf('//') === 0) src = 'https:' + src;
      var newSrc = resizeImage(src, 720);
      if (mainImg && mainImg.getAttribute('src') !== newSrc) {
        /* Tiny fade for visual continuity when switching */
        mainImg.style.opacity = '0';
        mainImg.setAttribute('src', newSrc);
        mainImg.onload = function() { mainImg.style.opacity = '1'; };
        /* Safety: also clear opacity in case onload doesn't fire (cached image) */
        setTimeout(function() { mainImg.style.opacity = '1'; }, 250);
      }

      /* Update thumbnail active state */
      var thumbs = modal.querySelectorAll('[data-qa-thumb]');
      thumbs.forEach(function(t, i) { t.classList.toggle('is-active', i === idx); });
    }

    function openModal() {
      lastFocused = document.activeElement;
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(function() { modal.classList.add('is-open'); });
      document.documentElement.classList.add('qa-no-scroll');

      /* Move focus to close button for keyboard users */
      var closeBtn = modal.querySelector('.qa-modal__close');
      if (closeBtn) closeBtn.focus();
    }

    function closeModal() {
      loadToken++;   /* any in-flight load must not render into the closed modal */
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('qa-no-scroll');
      /* Wait for transition before hiding to keep aria-hidden semantics correct */
      setTimeout(function() {
        if (!modal.classList.contains('is-open')) {
          modal.hidden = true;
          bodyEl.innerHTML = '<div class="qa-modal__loading" data-qa-loading><div class="qa-modal__spinner"></div></div>';
          loadingEl = modal.querySelector('[data-qa-loading]');
          currentProduct = null;
          selectedVariant = null;
        }
      }, 250);
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    /* Skeleton shown immediately on open so the dialog never flashes empty
       or half-built while the product JSON / image are still arriving. Mirrors
       the real layout (image + title + price + size pills + button) so there
       is no layout jump when the real content replaces it. */
    var SKELETON_HTML =
      '<div class="qa-modal__inner qa-skeleton">' +
        '<div class="qa-gallery">' +
          '<div class="qa-main"><div class="ark-skeleton qa-sk qa-sk--img"></div></div>' +
        '</div>' +
        '<div class="qa-info">' +
          '<div class="ark-skeleton qa-sk qa-sk--line" style="width:35%"></div>' +
          '<div class="ark-skeleton qa-sk qa-sk--line qa-sk--lg" style="width:75%"></div>' +
          '<div class="ark-skeleton qa-sk qa-sk--line" style="width:30%"></div>' +
          '<div class="qa-sk-pills">' +
            '<span class="ark-skeleton qa-sk qa-sk--pill"></span>' +
            '<span class="ark-skeleton qa-sk qa-sk--pill"></span>' +
            '<span class="ark-skeleton qa-sk qa-sk--pill"></span>' +
            '<span class="ark-skeleton qa-sk qa-sk--pill"></span>' +
            '<span class="ark-skeleton qa-sk qa-sk--pill"></span>' +
          '</div>' +
          '<div class="ark-skeleton qa-sk qa-sk--btn"></div>' +
        '</div>' +
      '</div>';

    function showSkeleton() {
      if (bodyEl) bodyEl.innerHTML = SKELETON_HTML;
    }

    /* Warm the cache before the click so the dialog opens instantly. Fired on
       hover (desktop) and touchstart (mobile, ~100-300ms before the tap
       completes). Silent — failures just fall through to the normal fetch. */
    function prefetch(handle) {
      if (!handle || productCache[handle]) return;
      fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r) { return r.ok ? r.json() : null; })
        .then(function(p) { if (p) productCache[handle] = p; })
        .catch(function() {});
    }

    function loadProduct(handle) {
      var token = ++loadToken;
      if (productCache[handle]) {
        if (token === loadToken) render(productCache[handle]);
        return Promise.resolve();
      }
      return fetch('/products/' + encodeURIComponent(handle) + '.js', {
        headers: { 'Accept': 'application/json' }
      })
        .then(function(r) {
          if (!r.ok) throw new Error('Failed to load product');
          return r.json();
        })
        .then(function(p) {
          productCache[handle] = p;
          if (token === loadToken) render(p);   /* ignore if a newer load started or the modal closed */
        });
    }

    function addToCart() {
      if (!selectedVariant || !selectedVariant.available) return;
      var addBtn   = modal.querySelector('[data-qa-add]');
      var addLabel = modal.querySelector('[data-qa-add-label]');
      var feedback = modal.querySelector('[data-qa-feedback]');
      if (!addBtn || !addLabel) return;

      addBtn.disabled = true;
      addLabel.textContent = 'ADDING...';
      if (feedback) { feedback.textContent = ''; feedback.className = 'qa-feedback'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: selectedVariant.id, quantity: selectedQty })
      })
        .then(function(r) {
          if (!r.ok) return r.json().then(function(err) { throw err; });
          return r.json();
        })
        .then(function() {
          addLabel.textContent = 'ADDED ✓';
          if (feedback) {
            feedback.textContent = 'Added to your cart';
            feedback.className = 'qa-feedback qa-feedback--success';
          }
          /* Notify any cart-bubble / drawer listeners that cart changed */
          document.dispatchEvent(new CustomEvent('ark:cart-updated'));
          /* Update cart count bubble if present */
          fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
            var bubble = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
            if (bubble) bubble.textContent = cart.item_count;
            var bubbleWrap = document.querySelector('.cart-count-bubble');
            if (bubbleWrap && cart.item_count > 0) bubbleWrap.style.display = '';
          }).catch(function() {});
          /* Auto-reset button after a moment so user can add another size */
          setTimeout(function() {
            addBtn.disabled = !selectedVariant.available;
            addLabel.textContent = selectedVariant.available ? 'ADD TO CART' : 'SOLD OUT';
          }, 1800);
        })
        .catch(function(err) {
          addBtn.disabled = false;
          addLabel.textContent = 'ADD TO CART';
          if (feedback) {
            feedback.textContent = (err && err.description) || 'Could not add to cart. Please try again.';
            feedback.className = 'qa-feedback qa-feedback--error';
          }
        });
    }

    /* ---- Event wiring (delegated on document for triggers, on modal for actions) ---- */

    document.addEventListener('click', function(e) {
      var trigger = e.target.closest('[data-qa-trigger]');
      if (!trigger) return;
      var handle = trigger.getAttribute('data-product-handle');
      if (!handle) return;
      e.preventDefault();
      e.stopPropagation();
      openModal();
      showSkeleton();
      loadProduct(handle).catch(function() {
        /* On failure, fall back to PDP */
        var url = trigger.getAttribute('href');
        if (url) window.location.href = url;
      });
    });

    /* Prefetch on intent (hover / touch start) for a near-instant open */
    document.addEventListener('pointerover', function(e) {
      var t = e.target.closest && e.target.closest('[data-qa-trigger]');
      if (t) prefetch(t.getAttribute('data-product-handle'));
    }, { passive: true });
    document.addEventListener('touchstart', function(e) {
      var t = e.target.closest && e.target.closest('[data-qa-trigger]');
      if (t) prefetch(t.getAttribute('data-product-handle'));
    }, { passive: true });

    /* Close on overlay/X */
    modal.addEventListener('click', function(e) {
      if (e.target.closest('[data-qa-close]')) {
        e.preventDefault();
        closeModal();
      }
    });

    /* ESC closes */
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    /* Modal interactions (delegated within modal) */
    modal.addEventListener('click', function(e) {
      var pill = e.target.closest('[data-qa-option]');
      if (pill) {
        selectOption(+pill.getAttribute('data-qa-option'), pill.getAttribute('data-qa-value'));
        return;
      }
      var qty = e.target.closest('[data-qa-qty]');
      if (qty) {
        setQty(selectedQty + (+qty.getAttribute('data-qa-qty')));
        return;
      }
      var thumb = e.target.closest('[data-qa-thumb]');
      if (thumb) { showImage(+thumb.getAttribute('data-qa-thumb')); return; }
      if (e.target.closest('[data-qa-prev]')) { showImage(galleryIndex - 1); return; }
      if (e.target.closest('[data-qa-next]')) { showImage(galleryIndex + 1); return; }
      if (e.target.closest('[data-qa-add]'))  { addToCart(); return; }
    });

    modal.addEventListener('input', function(e) {
      if (e.target.matches('[data-qa-qty-input]')) setQty(e.target.value);
    });
  }

  /* ---- Initialize ---- */
  document.addEventListener('DOMContentLoaded', function () {
    initHeaderShrink();
    initParallax();
    initTouchSwipe();
    initSmoothScroll();
    initImageFadeIn();
    initVideoHero();
    initMarqueeAccessibility();
    initProductCarouselArrows();
    initQuickAdd();
  });
})();

/* ============================================================================
   BS card image carousel — v26 (consolidated)
   Single source of truth for product-card image switching. Replaces the old
   v25 module AND the duplicate inline script that used to live in
   sections/best-sellers.liquid, so each card now has ONE set of listeners
   instead of two (perf + no double-firing).

   Behaviour:
   - Desktop (fine pointer + hover): moving the cursor across the image reveals
     images by horizontal position; leaving resets to the first image.
   - Dots: click jumps to that image.
   - Home page only: prev/next arrow buttons (rendered in the snippet) flip
     images. There is deliberately NO touch-swipe image switching here, so a
     horizontal swipe scrolls the product row instead of fighting it.
   - Focus tracking: on mobile the card whose centre is nearest the row centre
     gets .is-focused, which reveals its arrows (see CSS). Bound only to rows
     that actually contain arrows (the home page), so collection/product pages
     are untouched.
   - Idempotent via the data-bs-carousel guard.
   ============================================================================ */
(function () {
  'use strict';

  var fineHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function initCard(card) {
    if (card.dataset.bsCarousel === '1') return;
    card.dataset.bsCarousel = '1';

    var media  = card.querySelector('.bs-card__media');
    var images = card.querySelectorAll('.bs-card__image');
    var dots   = card.querySelectorAll('.bs-dot');
    if (!media || images.length < 2) return;

    var current = 0;

    function setActive(index) {
      if (index < 0) index = 0;
      if (index > images.length - 1) index = images.length - 1;
      current = index;
      for (var i = 0; i < images.length; i++) images[i].classList.toggle('active', i === index);
      for (var j = 0; j < dots.length; j++) dots[j].classList.toggle('active', j === index);
    }

    /* Desktop: position-based reveal across the image.
       Bound to the CARD, not .bs-card__media, because the full-card click
       overlay (.bs-card__overlay-link, z-index:1) sits on top of the media and
       was swallowing these mouse events (killing the hover image-swap). Events
       still bubble from the overlay up to the card, so the swap works again.
       The vertical-bounds guard keeps it reacting only while the pointer is
       actually over the image area — identical to the original behaviour. */
    if (fineHover) {
      card.addEventListener('mousemove', function (e) {
        var rect = media.getBoundingClientRect();
        if (!rect.width) return;
        if (e.clientY < rect.top || e.clientY > rect.bottom) return;
        var pct = (e.clientX - rect.left) / rect.width;
        if (pct < 0 || pct > 1) return;
        var idx = Math.min(Math.floor(pct * images.length), images.length - 1);
        if (idx >= 0 && idx !== current) setActive(idx);
      });
      card.addEventListener('mouseleave', function () { setActive(0); });
    }

    /* Dots */
    for (var k = 0; k < dots.length; k++) {
      (function (idx) {
        dots[idx].addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          setActive(idx);
        });
      })(k);
    }

    /* Per-image arrows (present in DOM on the home page only) */
    var prevBtn = card.querySelector('[data-bs-img-prev]');
    var nextBtn = card.querySelector('[data-bs-img-next]');
    if (prevBtn) prevBtn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation(); setActive(current - 1);
    });
    if (nextBtn) nextBtn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation(); setActive(current + 1);
    });

    /* Touch-swipe to change images — ONLY for cards in a standalone grid
       (e.g. collection pages). Cards inside a horizontal carousel
       (.bs-grid / .ark-na-track: the home rows + related products) skip
       this so a horizontal swipe scrolls the row instead of fighting it;
       the home rows use arrows, related products use dots. Passive
       listeners (no preventDefault) keep scrolling smooth. */
    if (!card.closest('.bs-grid, .ark-na-track')) {
      var sx = 0, sy = 0, tracking = false;
      media.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; tracking = true;
      }, { passive: true });
      media.addEventListener('touchend', function (e) {
        if (!tracking) return;
        tracking = false;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) < 30 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        setActive(dx < 0 ? current + 1 : current - 1);
      }, { passive: true });
      media.addEventListener('touchcancel', function () { tracking = false; }, { passive: true });
    }
  }

  /* Mark the card nearest each row's centre as .is-focused (drives mobile
     arrow visibility). Bound only to rows that contain arrow buttons. */
  function initFocusTracking() {
    var rows = document.querySelectorAll('.bs-grid, .ark-na-track');
    for (var r = 0; r < rows.length; r++) {
      (function (row) {
        if (row.dataset.bsFocusBound === '1') return;
        if (!row.querySelector('[data-bs-img-next]')) return; /* not the home page */
        row.dataset.bsFocusBound = '1';

        function update() {
          var rect = row.getBoundingClientRect();
          var centre = rect.left + rect.width / 2;
          var cards = row.querySelectorAll('[data-bs-card]');
          var best = null, bestDist = Infinity;
          for (var i = 0; i < cards.length; i++) {
            var cr = cards[i].getBoundingClientRect();
            var d = Math.abs((cr.left + cr.width / 2) - centre);
            if (d < bestDist) { bestDist = d; best = cards[i]; }
          }
          for (var j = 0; j < cards.length; j++) {
            cards[j].classList.toggle('is-focused', cards[j] === best);
          }
        }

        var t;
        row.addEventListener('scroll', function () {
          clearTimeout(t); t = setTimeout(update, 60);
        }, { passive: true });
        window.addEventListener('resize', function () {
          clearTimeout(t); t = setTimeout(update, 120);
        });
        update();
        setTimeout(update, 300);
      })(rows[r]);
    }
  }

  function init() {
    var cards = document.querySelectorAll('[data-bs-card]');
    for (var i = 0; i < cards.length; i++) initCard(cards[i]);
    initFocusTracking();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-init on Shopify section load (theme editor) */
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }

  window.arkBSCardCarouselInit = init;
})();

/* ============================================================================
   MEGA MENU — per-product hover image swap. Hovering a product sublink shows
   that product's image in the featured area; leaving the columns reverts to
   the collection crossfade handled by global.js.
   ============================================================================ */
(function () {
  function initMegaPreview() {
    document.querySelectorAll('details.mega-menu').forEach(function (menu) {
      var preview = menu.querySelector('.mega-menu__preview-img');
      var area = menu.querySelector('.mega-menu__links-area');
      if (!preview || !area) return;
      menu.querySelectorAll('.mega-menu__sublink[data-mega-img]').forEach(function (a) {
        a.addEventListener('mouseenter', function () {
          var src = a.getAttribute('data-mega-img');
          if (!src) return;
          preview.setAttribute('src', src);
          preview.classList.add('is-active');
        });
      });
      area.addEventListener('mouseleave', function () {
        preview.classList.remove('is-active');
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaPreview);
  } else {
    initMegaPreview();
  }
})();


/* ============================================================================
   ARK — Image skeletons
   Adds a shimmer placeholder to an image's holder while it downloads, then
   removes it on load/error. Targets lazy images, dedupes per holder so the
   visible (first) image controls the placeholder, and re-checks for the
   cached/already-complete race. Pure progressive enhancement.
   ============================================================================ */
(function () {
  'use strict';

  function holderFor(img) {
    return img.closest(
      '.card__media, .media, .banner__media, .collection-card__media'
    ) || img.parentElement;
  }

  function initSkeletons() {
    var imgs = document.querySelectorAll('img[loading="lazy"]');
    var seen = (typeof WeakSet !== 'undefined') ? new WeakSet() : null;

    for (var i = 0; i < imgs.length; i++) {
      (function (img) {
        if (img.complete && img.naturalWidth > 0) return;
        var holder = holderFor(img);
        if (!holder) return;
        if (seen) {
          if (seen.has(holder)) return;
          seen.add(holder);
        }

        holder.classList.add('ark-skeleton');
        function done() { holder.classList.remove('ark-skeleton'); }
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });

        /* Guard against the load firing between our check and listener bind */
        if (img.complete && img.naturalWidth > 0) done();
      })(imgs[i]);
    }
  }

  /* Full-card skeletons for product cards — the exact card shape (image +
     title + price bars). JS-driven so no-JS users always get real cards;
     cleared when the card's primary image loads, on error, or after a safety
     timeout so a card can never get stuck as a skeleton. */
  function initCardSkeletons() {
    var cards = document.querySelectorAll('[data-bs-card]');
    for (var i = 0; i < cards.length; i++) {
      (function (card) {
        var img = card.querySelector('.bs-card__image');
        if (!img) return;
        if (img.complete && img.naturalWidth > 0) return;
        card.classList.add('bs-loading');
        var cleared = false;
        function clear() { if (cleared) return; cleared = true; card.classList.remove('bs-loading'); }
        img.addEventListener('load', clear, { once: true });
        img.addEventListener('error', clear, { once: true });
        if (img.complete && img.naturalWidth > 0) clear();
        setTimeout(clear, 6000);
      })(cards[i]);
    }
  }

  function runSkeletons() { initSkeletons(); initCardSkeletons(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runSkeletons);
  } else {
    runSkeletons();
  }

  /* Re-apply on Shopify section reload (theme editor) */
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', runSkeletons);
  }
})();